document.addEventListener('DOMContentLoaded', function() {
  var searchIcon = document.getElementById('search-icon');
  var searchForm = document.getElementById('search-form');

  searchIcon.addEventListener('click', function() {
    if (searchForm.style.display === 'none' || searchForm.style.display === '') {
      searchForm.style.display = 'block';
    } else {
      searchForm.style.display = 'none';
    }
  });
});